// M60-S 的入口和加载页共用项目终态；百分比不参与是否放行的判断。
export function getM60ReportProgress(scan, report) {
    if (!report) throw new Error('Missing M60 report status')
    const projects = []
    const add = (name, enabled, value) => {
        if (!enabled) return
        const status = value === null || value === undefined ? NaN : Number(value)
        projects.push({ name, status })
    }
    const measured = value => Number(value) === 1
    add('body', measured(scan.biaMeasure), scan.bmBiaScanInfo && scan.bmBiaScanInfo.result)
    add('posture', measured(scan.staticEval), scan.bsScanInfo && scan.bsScanInfo.result)
    add('girth', measured(scan.girthMeasure), scan.bmBdaScanInfo && scan.bmBdaScanInfo.result)
    add('shoulder', measured(scan.shoulderJointEval), scan.bsShoulderScanInfo && scan.bsShoulderScanInfo.result)
    add('neck', measured(scan.dynamicEval), scan.bsNeckScanInfo && scan.bsNeckScanInfo.result)
    // balanceMeasure 是测量开关；沿用现有报告入口的 1=可展示约定，不能当合成状态枚举。
    add('balance', measured(scan.balanceMeasure), 1)
    // 派生结果仅在对应主项目存在且服务端返回该任务时参与等待。
    add('spine', measured(scan.staticEval) && !!scan.bsSpineScanInfo, scan.bsSpineScanInfo && scan.bsSpineScanInfo.result)
    add('hip', (measured(scan.biaMeasure) || measured(scan.girthMeasure)) && !!scan.hipScanInfo, scan.hipScanInfo && scan.hipScanInfo.result)
    for (const name of ['infrared', 'vitalSign']) {
        const flag = report[name + 'Measure']
        const status = report[name + 'Status']
        const enabled = flag == null ? [-10, -1, 1, 2].includes(Number(status)) : measured(flag)
        add(name, enabled, status)
    }
    const missing = projects.some(p => ![-10, -1, 0, 1, 2].includes(p.status))
    const pending = projects.some(p => [-10, -1].includes(p.status))
    const finished = projects.filter(p => [0, 1, 2].includes(p.status)).length
    const success = projects.some(p => p.status === 1)
    return {
        projects,
        percent: projects.length ? Math.floor(finished * 100 / projects.length) : 0,
        route: missing || !projects.length ? '/exception/report' : pending ? '/modeling' : success ? '/report' : '/exception/report',
    }
}
